import { Teacher, StudentClass, LessonPrivilegeSettingsForForm, PrevResults, Answer } from '.';
export { SubjectFileModel } from '@app/_interfaces/SubjectFileModel';

export interface SmartSprint {
    id: number;
    reward: number;
    duration: number;
    lesson: number;
    box: number;
    successful: boolean;
}

export interface SchoolSubject {
    id: number;
    teachers: Teacher[];
    created: Date;
    updated: Date;
    title: string;
}

export interface ISubject {
    id: number;
    title: string;
}

export interface School {
    id: number;
    title: string;
    logo?: string;
}

export interface Section {
    id: number;
    created: Date;
    updated: Date;
    title: string;
    subject: number;
}

export interface Lesson {
    id: number;
    teacher: number;
    subject: number;
    is_online: boolean;
    is_author?: boolean;
    subject_obj: SchoolSubject;
    student_class_obj: StudentClass;
    section_obj: Section;
    created: Date;
    updated: Date;
    lesson_number: number;
    date: Date;
    status: number;
    student_class: number;
    theme: any;
    section: number;
    start_time: Date;
    end_time: Date;
    duration: number;
    epoch: number;
    title?: string;
    remarks?: string;
    lesson_part?: number;
    full_lesson_number: string;
    attending_students: Array<number>;
    reward_with_cash: boolean;
    payment_for_task_with_cash: boolean;
    has_kairos_bonus: boolean;
    privileges: Array<LessonPrivilegeSettingsForForm>;
    smart_sprints: Array<SmartSprint>;
    is_habirint?: boolean;
}

export interface LessonForCopy {
    date: Date;
    lesson_number: number;
    lesson_title: string;
    lesson_remarks: string;
    student_class: number;
    source_lesson: number;
}

export class LessonPagination {
    id: number;
    lesson_number: number;
    full_lesson_number: string;
    subject: ISubject;
    student_class_title: string;
    student_class: {
        id: number;
        title: string;
        school: School;
    };
    is_smart_sprint: boolean;
    is_author: boolean;
    status: any;
    date: Date;
    start_time: Date;
    end_time: Date;
    title: string;
    remarks: string;
}

export interface ILessonRequest {
    count: number;
    is_subject_column_hidden: boolean;
    is_class_column_hidden: boolean;
    page: number;
    pages_count: number;
    results: Lesson[];
}

export interface Theme {
    id: number;
    subtopics: Array<Subtopic>;
    created: Date;
    updated: Date;
    title: string;
    subject: number;
    section: number;
    number: number;
}

export interface Subtopic {
    id: number;
    author: any;
    created: Date;
    is_global: boolean;
    theme: number;
    title: string;
    updated: Date;
    file_id: number;
    comment: string;
    type: string;
}

export interface FileWithTask {
    id: number;
    theme: Theme;
    subtopic: Subtopic;
    attributes: Array<string>;
    created: Date;
    updated: Date;
    title?: string;
    str_title: string;
    file: string;
    instruction?: string;
    comments: string;
    type: string;
}

export interface Greeting {
    id: number;
    created: Date;
    updated: Date;
    text: string;
    is_success: boolean;
}

export interface LastSymbol {
    id: number;
    symbol: string;
}

export interface CardInterface {
    id: number;
    exercises: Array<any>;
    box: any;
    box_level: number;
    lesson_date: Date;
    attempts: number;
    created: Date;
    updated: Date;
    card_number: number;
    image: string;
    card_status: string;
    card_text?: string;
    prev_results: PrevResults;
}

export interface Section {
    id: number;
    created: Date;
    updated: Date;
    title: string;
    subject: number;
}

export interface ICardData {
    card: number;
    student: number;
    earned_amount: number;
    transaction_type: string;
    penalty: number;
    cost: number;
    tasks_time: number;
    answers: Answer[];
}

export interface CardTemplate {
    id: number;
    exercises: Array<any>;
    files: Array<number>;
    number_of_exercises: number;
    instruction: string;
    created: Date;
    updated: Date;
}

export interface TemplateForBox {
    box_title: string;
    template: CardTemplate;
}

export interface FileForBox {
    box_title: string;
    files: Array<FileWithTask>;
}

export interface LastClassLessonNumber {
    class_id: number;
    lesson_number: number;
}

export interface ShortDataLesson {
    id: number;
    date: Date;
    epoch: number;
    status: number;
    lesson_number: number;
    title: string | null;
    payment_for_task_with_cash: boolean;
    reward_with_cash: boolean;
    has_kairos_bonus: boolean;
    class_title: string;
    student_class_title?: string;
    class_id: number;
    subject: string;
    remarks: string | null;
    smart_sprints: Array<SmartSprint>;
    is_habirint?: boolean;
    is_online?: boolean;
    is_author?: boolean;
}
